import WidgetModel, { WidgetTypes } from '@mm/state/model/WidgetModel';

const MESSAGE_LENGTH_CAP = 160;

export const validateSmsRelatedWidgets = (widgets: WidgetModel[]): boolean => {
  const textBasedWidgets = widgets.filter(({ type }) =>
    [WidgetTypes.QUICK_QUESTION, WidgetTypes.TEXT].includes(type),
  );

  const imageBasedWidgets = widgets.filter(({ type }) =>
    [WidgetTypes.IMAGE, WidgetTypes.GIF, WidgetTypes.VIDEO].includes(type),
  );

  // User has more than just a single Text/QQ widget
  if (textBasedWidgets.length > 1) {
    return false;
  }

  // User has more than just .. single Image/GIF widget
  if (imageBasedWidgets.length > 1) {
    return false;
  }

  const textOverCap = textBasedWidgets.some(
    widget => (widget?.smsStructure?.body?.length || 0) > MESSAGE_LENGTH_CAP,
  );

  // text or qq widget > 160 characters
  if (textOverCap) {
    return false;
  }

  return true;
};

export const showMMSMessageWarning = (
  pageWidgets: WidgetModel[],
  widgetId: number,
): boolean => {
  const filteredPageWidgets = pageWidgets?.filter(({ type }) =>
    [
      WidgetTypes.TEXT,
      WidgetTypes.QUICK_QUESTION,
      WidgetTypes.FORM,
      WidgetTypes.GIF,
      WidgetTypes.IMAGE,
      WidgetTypes.VIDEO,
    ].includes(type),
  );
  const mediaTypes = [WidgetTypes.IMAGE, WidgetTypes.GIF, WidgetTypes.VIDEO];

  if (!filteredPageWidgets || !filteredPageWidgets?.length) {
    return false;
  }
  const index = filteredPageWidgets?.findIndex(w => w.id === widgetId);
  const nextWidget = filteredPageWidgets[index + 1];
  const prevWidget = filteredPageWidgets[index - 1];

  if (
    (prevWidget?.validated?.facebook && mediaTypes.includes(prevWidget.type)) ||
    (nextWidget?.validated?.facebook && mediaTypes.includes(nextWidget.type))
  ) {
    return false;
  }

  return true;
};
